<template>
    <div class="col-12">
        <h4>{{ __('left_to_be_invoiced') }}</h4>
        <DataTable
            :data="items"
            :options="tableOptions"
            :summary="summary"
            :detailed="detailed"
        />
    </div>
</template>

<script>
import DataTable from "../../../table/DataTable";

export default {
    name: "LeftToBeInvoicedDetailedTable",
    components: {DataTable},
    props: {
        contractDetailedItemsSummaries: {
            type: Array | Object,
            required: true,
        },
        contractType: {
            type: Object,
            required: true,
        },
        detailed:{
            type: Boolean,
            default:false
        }
    },
    computed: {
        contractTable() {
            return {
                data: [
                    {name: this.__('item_name'), valueKey: 'name', type: '', wrap: 85},
                    {name: this.__('item_vat_rate'), valueKey: 'vat_rate_list', type: ''},
                    {name: this.__('unit_price'), valueKey: 'price', type: 'money'},
                    {name: this.__('item_quantity'), valueKey: 'quantity', type: 'money'},
                    {name: this.__('net_amount'), valueKey: 'net_amount', type: 'money'},
                    {name: this.__('gross_amount'), valueKey: 'gross_amount', type: 'money'},
                    {name: this.__('remaining_quantity'), valueKey: 'quantity_left', type: 'money'},
                    {name: this.__('net_amount_left'), valueKey: 'net_amount_left', type: 'money'},
                    {name: this.__('gross_amount_left'), valueKey: 'gross_amount_left', type: 'money'},
                ],
                summary: [
                    {name: this.__('sum')},
                    {name: ''},
                    {name: ''},
                    {name: ''},
                    {valueKey: 'sum_net_amount', type: 'money'},
                    {valueKey: 'sum_gross_amount', type: 'money'},
                    {name: ''},
                    {valueKey: 'sum_net_amount_left', type: 'money'},
                    {valueKey: 'sum_gross_amount_left', type: 'money'},
                ],
            };
        },
        marginContractTable() {
            return {
                data: [
                    {name: this.__('item_name'), valueKey: 'name', type: '', wrap: 85},
                    {name: this.__('unit_price'), valueKey: 'price', type: 'money'},
                    {name: this.__('item_quantity'), valueKey: 'quantity', type: 'money'},
                    {name: this.__('value'), valueKey: 'gross_amount', type: 'money'},
                    {name: this.__('margin_amount_included'), valueKey: 'margin', type: 'money'},
                    {name: this.__('remaining_quantity'), valueKey: 'quantity_left', type: 'money'},
                    {name: this.__('value_left'), valueKey: 'gross_amount_left', type: 'money'},
                    {name: this.__('gross_margin_left'), valueKey: 'margin_left', type: 'money'},
                ],
                summary: [
                    {name: this.__('sum')},
                    {name: ''},
                    {name: ''},
                    {valueKey: 'sum_gross_amount', type: 'money'},
                    {valueKey: 'sum_margin', type: 'money'},
                    {name: ''},
                    {valueKey: 'sum_gross_amount_left', type: 'money'},
                    {valueKey: 'sum_margin_left', type: 'money'},
                ],
            };
        },
        tableOptions() {
            return this.contractType.isMargin ? this.marginContractTable : this.contractTable;
        },
        summary() {
            return this.contractDetailedItemsSummaries.summary;
        },
        items() {
            return this.contractDetailedItemsSummaries.items;
        },
    },
};
</script>
